import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

export const getActivityReportState = (state: NutshellState) => state.reports.activity;

/**
 * Detail tab selectors
 */
export const getDetailState = createSelector([getActivityReportState], (activityReportState) => {
    return activityReportState.detail;
});

export const getDetailIsLoading = createSelector([getDetailState], (detailState) => {
    return detailState.isLoading;
});

export const getDetailHasError = createSelector([getDetailState], (detailState) => {
    return detailState.hasError;
});

export const getDetailContent = createSelector([getDetailState], (detailState) => {
    return detailState.data;
});

export const getDetailNumPages = createSelector([getDetailState], (detailState) => {
    return detailState.numPages ? detailState.numPages : 1;
});

/**
 * Activities tab selectors
 */
export const getActivitiesState = createSelector(
    [getActivityReportState],
    (activityReportState) => {
        return activityReportState.activities;
    }
);

export const getActivitiesIsLoading = createSelector([getActivitiesState], (activitiesState) => {
    return activitiesState.isLoading;
});

export const getActivitiesHasError = createSelector([getActivitiesState], (activitiesState) => {
    return activitiesState.hasError;
});

export const getActivitiesContent = createSelector([getActivitiesState], (activitiesState) => {
    return activitiesState.data;
});

export const getActivitiesNumPages = createSelector([getActivitiesState], (activitiesState) => {
    return activitiesState.numPages ? activitiesState.numPages : 1;
});

/**
 * Summary tab selectors
 */
export const getSummaryState = createSelector([getActivityReportState], (activityReportState) => {
    return activityReportState.summary;
});

export const getSummaryIsLoading = createSelector([getSummaryState], (summaryState) => {
    return summaryState.isLoading;
});

export const getSummaryHasError = createSelector([getSummaryState], (summaryState) => {
    return summaryState.hasError;
});

export const getSummaryData = createSelector([getSummaryState], (summaryState) => {
    return summaryState.data;
});

export const getSummaryTotals = createSelector([getSummaryState], (summaryState) => {
    return summaryState.totals;
});

/**
 * leadOutcomes
 */

export const getLeadOutcomes = (state: NutshellState) => getActivityReportState(state).leadOutcomes;
